import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { MyCouponsEdit } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { useGetMyCouponDetail } from '@services/useGetMyCouponDetail';

export function MyCouponsEditPage() {
    const { myCouponDetail } = useData();
    const { request: requestMyCouponDetail } = useGetMyCouponDetail();
    const { uuid } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('my-coupons-edit-component.metatags.title', { name: myCouponDetail?.data?.promo_code }),
        description: t('my-coupons-edit-component.metatags.description', { name: myCouponDetail?.data?.promo_code }),
    };

    // fetch coupon detail info
    useEffect(() => {
        requestMyCouponDetail({ uuid: uuid || '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myCouponsEdit.replace(':uuid', `${uuid}`),
        index: false,
    });

    return <MyCouponsEdit />;
}
